import { render } from "./SampleSpinner.vue?vue&type=template&id=3f85590f"
import script from "./SampleSpinner.vue?vue&type=script&lang=js"
export * from "./SampleSpinner.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"static/js/components-wa/loaders/SampleSpinner.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3f85590f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3f85590f', __exports__)) {
    api.reload('3f85590f', __exports__)
  }
  
  module.hot.accept("./SampleSpinner.vue?vue&type=template&id=3f85590f", () => {
    api.rerender('3f85590f', render)
  })

}


export default __exports__